import { Box } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { ViewStyle } from 'react-native'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import Home from '../Home'

const Landing: FC = () => {
  const [navVisible, setNavVisible] = useState(false)

  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  return (
    <Box flex={1}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar isBg={false} onPress={handleNav} hamBurgerType="secondary" isLightBackground={true} />
      <Home />
    </Box>
  )
}

export const styles = () => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    } as ViewStyle,
  }
}

export default Landing
